module.exports = __webpack_public_path__ + "static/media/Awards.17a34a4e.png";